import React from "react";
import { DashboardLayout } from "../Components";
const ClientBillDomestic=()=>{
    return(
        <div>
            <DashboardLayout>
            <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">View Client Bills</h5>
                </div>
            </DashboardLayout>
        </div>
    )
}
export {ClientBillDomestic}